import React, {Component} from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import ProductItemListPageUI from './ProductItemListPageUI.js'
import RestApiUtils from "../../apiclient/moebli/RestApiUtils";
import MessageUtils from "../../util/MessageUtils";

class ProductItemListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      inventoryItemList: null,
      filteredProductItemList: null,
      // filters
      searchFilter: '',
      //
      successMsg: null,
      errorMsgList: null,
      errorList: null,
      createMode: false,
      updateMode: false,
      deleteMode: false,
      submitted: false,
      uploadSubmitted: false,
      selectedCount: 0,
    }
  }

  render() {
    return (
      <ProductItemListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        inventoryItemList={this.state.inventoryItemList}
        filteredProductItemList={this.state.filteredProductItemList}
        // filters
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        // form
        successMsg={this.state.successMsg}
        errorMsgList={this.state.errorMsgList}
        errorList={this.state.errorList}
        setErrorList={(errorList) => {this.setState({errorList: errorList})}}
        // modes
        selectedCount={this.state.selectedCount}
        updateMode={this.state.updateMode}
        deleteMode={this.state.deleteMode}
        submitted={this.state.submitted}
        uploadSubmitted={this.state.uploadSubmitted}
        // events
        onRowClick={this.onRowClick}
        onRefreshClick={this.onRefreshClick}
        onCreateClick={this.onCreateClick}
        onUpdateClick={this.onUpdateClick}
        onDeleteClick={this.onDeleteClick}
        onUploadSubmit={this.onUploadSubmit}
        onConfirmCreateClick={this.onConfirmCreateClick}
        onConfirmUpdateClick={this.onConfirmUpdateClick}
        onConfirmDeleteClick={this.onConfirmDeleteClick}
        onCancelClick={this.onCancelClick}
        // create product item modal
        onCreateProductItemClick={(event) => { this.setState({createMode: true}) }}
        createProductItemMode={this.state.createMode}
        onCancelCreateProductItem={(event) => { this.setState({createMode: false}) }}
        onCreateProductItemComplete={this.onCreateProductItemComplete}
        // update product item modal
        onUpdateProductItemClick={(event) => { this.setState({updateMode: true}) }}
        updateProductItemMode={this.state.updateMode}
        onCancelUpdateProductItem={(event) => { this.setState({updateMode: false}) }}
        onUpdateProductItemComplete={this.onUpdateProductItemComplete}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProductItems(context)
    this.getMessages(context)
    // https://stackoverflow.com/questions/48269381/warning-react-modal-app-element-is-not-defined-please-use-modal-setappeleme
    Modal.setAppElement('body')
  }

  getProductItems(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/inventoryItems`,
      cacheKey: CacheKeys.InventoryItems(context.session.accountId),
      callback: this.getProductItemsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProductItemsCallback = (response) => {
    response.inventoryItemList && response.inventoryItemList.forEach(productItem => {
      productItem.selected = false
    })

    let filtersStr = sessionStorage.getItem(CacheKeys.InventoryItemsFilter(this.props.context.session.accountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(response.inventoryItemList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
    // this.setState({errorList: response.errorList, inventoryItemList : response.inventoryItemList})
  }

  applyFilters(inventoryItemList, searchFilter, errorList) {
    let filteredList = inventoryItemList
    if (searchFilter)
      filteredList = filteredList.filter(item =>
        item.itemName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()) ||
        item.maker && item.maker.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()) ||
        item.category && item.category.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase())
      )

    // remove checked flag from rows that are hidden
    let selectedSet = new Set()
    inventoryItemList.filter(item => item.selected).forEach(item => {selectedSet.add(item.id)})
    inventoryItemList.forEach(item => {item.selected = false})
    filteredList.filter(item => selectedSet.has(item.id)).forEach(item => {item.selected = true})

    this.setState({
      inventoryItemList : inventoryItemList,
      filteredProductItemList: filteredList,
      searchFilter: searchFilter,
      selectedCount: filteredList.filter(item => item.selected).length,
      errorList: errorList
    })

    let filters = {searchFilter: searchFilter}
    sessionStorage.setItem(CacheKeys.InventoryItemsFilter(this.props.context.session.accountId), JSON.stringify(filters))
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.InventoryItems(context.session.accountId))
    this.setState({errorList: null, inventoryItemList: null})
    this.getProductItems(context)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.state.inventoryItemList, searchFilter)
  }

  onRowClick = (event) => {
    let id = event.currentTarget.getAttribute('data-row-id')
    let inventoryItemList = this.state.inventoryItemList
    inventoryItemList
      .filter(productItem => productItem.id == id)
      .forEach(productItem => {
        console.log(productItem);
        productItem.selected = !Boolean(productItem.selected)
      })

    this.setState({inventoryItemList : inventoryItemList})
    this.applyFilters(inventoryItemList, this.state.searchFilter)
  }

  onCreateProductItemComplete = (product) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.InventoryItems(context.session.accountId))

    let inventoryItemList = this.state.inventoryItemList
    inventoryItemList.unshift(product)

    this.setState({ inventoryItemList: inventoryItemList })

    setTimeout(() => {
      this.setState({ createMode: false })
    }, 2000)
  }


  onUploadSubmit = (file) => {

    // onUploadSubmit - get signed URL
    // onUploadFile - upload file
    // onUploadCompleteCallback - send request to process file
    // onUploadFileParsedCallback - server response

    let uploadSubmitted = this.state.uploadSubmitted
    if (uploadSubmitted) {
      return
    }

    let context = this.props.context
    this.setState({uploadSubmitted: true})

    let getResource = `${RestApiUtils.getServerUrl(context)}/api/accounts/` + context.session.accountId + `/productItems/upload/signedUrl` +
      `?fileName=${encodeURIComponent(file.name)}&type=${file.type}&size=${file.size}`

    console.log('-> GET', getResource)

    fetch(getResource, {
      headers: RestApiUtils.getHeaders(context),
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        console.log('<- GET', getResource, json)
        if (json.errorList.length) {

          this.setState({uploadSubmitted: false, errorMsgList: json.errorList})
          setTimeout(() => {
            this.setState({errorMsgList: null})
          }, 3000);

        } else {
          this.onUploadFile(json.signedUrl, file)
        }
      }).catch(err => {
        this.setState({uploadSubmitted: false, errorMsgList: MessageUtils.getUnknownError(this.state.messageList)});
        setTimeout(() => {
          this.setState({errorMsgList: null})
        }, 3000);
    })
  }

  onUploadFile = (signedUrl, file) => {

    console.log('-> PUT', signedUrl)
    console.log(file)

    const requestOptions = {
      method: 'PUT',
      body: file,
    };

    fetch(signedUrl, requestOptions)
      .then((response) => {
        console.log('<- PUT', signedUrl)
        console.log(response)
        this.onUploadCompleteCallback(signedUrl)
      })
      .catch(err => {
        this.setState({uploadSubmitted: false, errorMsgList: MessageUtils.getUnknownError(this.state.messageList)});
        setTimeout(() => {
          this.setState({errorMsgList: null})
        }, 3000);
      })
  }

  onUploadCompleteCallback = (signedUrl) => {

    let context = this.props.context

    let getResource = `${RestApiUtils.getServerUrl(context)}/api/accounts/` + context.session.accountId + `/productItems/upload/process` + `?signedUrl=${signedUrl}`

    const requestOptions = {
      headers: RestApiUtils.getHeaders(context),
    };

    console.log('-> GET', getResource)

    fetch(getResource, requestOptions)
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        console.log('<- GET', getResource, json);
        this.onUploadFileParsedCallback(json);

      })
      .catch(err => {
        this.setState({uploadSubmitted: false, errorMsgList: MessageUtils.getUnknownError(this.state.messageList)});
        setTimeout(() => {
          this.setState({errorMsgList: null})
        }, 3000);
      })

  }

  onUploadFileParsedCallback = (response) => {

    let context = this.props.context

    if (response.success !== null && response.success.length > 0) {

      this.setState({uploadSubmitted: false, successMsg: response.success})

      CacheManager.removeObject(CacheKeys.InventoryItems(context.session.accountId))
      this.getProductItems(context)

      setTimeout(() => {
        this.setState({successMsg: null})
      }, 3000);

    } else if (response.errorList != null) {

      this.setState({uploadSubmitted: false, errorMsgList: response.errorList})
      CacheManager.removeObject(CacheKeys.InventoryItems(context.session.accountId))

      setTimeout(() => {
        this.setState({errorMsgList: null})
      }, 5000);

    } else {

      this.setState({uploadSubmitted: false, errorList: MessageUtils.getUnknownError(this.state.messageList)});
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})

    }

  }

  onUpdateProductItemComplete = (product) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.InventoryItems(context.session.accountId))
    this.getProductItems(context)

    // let inventoryItemList = this.state.inventoryItemList
    // inventoryItemList = inventoryItemList.filter(item => item.id !== product.id)
    // inventoryItemList.unshift(product)

    // this.setState({ inventoryItemList: inventoryItemList })

    setTimeout(() => {
      this.setState({ updateMode: false })
      //this.props.history.push(`/settings/account/product-items`)
    }, 2000)
  }

  getMessages(context) {
    let arr = [
      'c_product_items',
      'c_refresh',
      'c_add_product_item',
      'c_product_added',
      'c_create_product_item',
      'c_update_product_item',
      'c_delete_product_item',
      'c_upload_csv',
      'c_unknown_error'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_acc_itm', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default ProductItemListPageSF
